import {
    Box,
    Button,
    Divider,
    Drawer,
    Stack,
    SvgIcon,
    Typography,
    useMediaQuery
} from '@mui/material';
import {Link, useLocation} from 'react-router-dom';
import { Scrollbar } from './ScrollBar';
import theme from "../../theme/theme";
import { SideNavItem } from './SideNavItems';
import SearchIcon from '@mui/icons-material/Search';
import GroupIcon from '@mui/icons-material/Group';
import PersonIcon from '@mui/icons-material/Person';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { LibraryBooks } from '@mui/icons-material';
import {userType} from "../../api/authService";
import {useSelector} from "react-redux";
import {RootState} from "../../app/store";

export const SideNav = (props: any) => {
    const { open, onClose } = props;
    const lgUp = useMediaQuery((theme: any) => theme.breakpoints.up('lg'));
    const user = useSelector((state: RootState) => state.auth.user );
    const location = useLocation();
    const pathname = location.pathname;

    const content = (
        <Scrollbar
            sx={{
                background: `${theme.palette.grey[800]} !important`,
                overflow: 'hidden',
                '& .simplebar-scrollbar:before': {
                    background: `${theme.palette.grey[900]} !important`
                }
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Box pl={3} pr={3}>
                    <Link to={'/home'}>
                        <Box
                            sx={{
                                display: 'inline-flex',
                                height: 130,
                                width: '100%',
                                boxSizing: 'border-box'
                            }}
                        >
                            <img
                                src="/assets/Group-77.svg"
                                alt="Lockup"
                                style={{width: '100%', height: '100%', objectFit: 'contain'}}
                            />
                        </Box>
                    </Link>
                </Box>
                <Divider sx={{borderColor: theme.palette.grey[700]}}/>
                <Box
                    component="nav"
                    sx={{
                        flexGrow: 1,
                        px: 2,
                        py: 4
                    }}
                >
                    <Stack
                        component="ul"
                        spacing={0.5}
                        sx={{
                            listStyle: 'none',
                            p: 0,
                            m: 0
                        }}
                    >
                        <SideNavItem
                            active={pathname === '/home'}
                            icon={<SearchIcon />}
                            path="/home"
                            title="Kërko"
                        />
                        <SideNavItem
                            active={pathname === '/clients'}
                            icon={<GroupIcon />}
                            path="/clients"
                            title="Klientët"
                        />
                        <SideNavItem
                            active={pathname === '/orders'}
                            icon={<ShoppingCartIcon />}
                            path="/orders"
                            title="Blerjet"
                        />
                        {/* Super Admin Only Menu Items */}
                        {user?.userType === 'super-admin' && (
                            <>
                                <SideNavItem
                                    active={pathname === '/sales'}
                                    icon={<MenuBookIcon />}
                                    path="/sales"
                                    title="Libri i shitjeve"
                                />
                                <SideNavItem
                                    active={pathname === '/reports'}
                                    icon={<LibraryBooks />}
                                    path="/reports"
                                    title="Reports"
                                />
                                <SideNavItem
                                    active={pathname === '/users'}
                                    icon={<PersonIcon />}
                                    path="/users"
                                    title="Përdoruesit"
                                />
                                <SideNavItem
                                    active={pathname === '/import'}
                                    icon={
                                        <SvgIcon>
                                            <path d="M19 9h-4V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2zM14 5.5L18.5 10H15c-.55 0-1-.45-1-1V5.5zM19 19H5V5h7v4c0 1.66 1.34 3 3 3h4v7z" />
                                            <path d="M7 14h10v2H7zM7 11h10v2H7zM7 8h10v2H7z" />
                                        </SvgIcon>
                                    }
                                    path="/import"
                                    title="Importo Excel"
                                />  
                            </>
                        )}
                    </Stack>
                </Box>
                <Divider sx={{ borderColor: theme.palette.grey[700] }} />
            </Box>
        </Scrollbar>
    );

    if (lgUp) {
        return (
            <Drawer
                anchor="left"
                open
                PaperProps={{
                    sx: {
                        backgroundColor: theme.palette.grey[800],
                        color: 'common.white',
                        width: 280
                    }
                }}
                variant="permanent"
            >
                {content}
            </Drawer>
        );
    }

    return (
        <Drawer
            anchor="left"
            onClose={onClose}
            open={open}
            PaperProps={{
                sx: {
                    backgroundColor: theme.palette.grey[800],
                    color: 'common.white',
                    width: 280
                }
            }}
            sx={{ zIndex: (theme) => theme.zIndex.appBar + 100 }}
            variant="temporary"
        >
            {content}
        </Drawer>
    );
};